import type { SubscriptionTier, SubscriptionStatus, MemberRole } from '../types/api';
import styles from './Badge.module.css';

interface TierBadgeProps {
  tier: SubscriptionTier | null;
}

export function TierBadge({ tier }: TierBadgeProps) {
  const effectiveTier = tier || 'free';
  return (
    <span className={`${styles.badge} ${styles[effectiveTier]}`}>
      {effectiveTier}
    </span>
  );
}

interface StatusBadgeProps {
  status: SubscriptionStatus | null;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  if (!status) return null;
  const displayStatus = status.replace('_', ' ');
  return (
    <span className={`${styles.badge} ${styles[status]}`}>
      {displayStatus}
    </span>
  );
}

interface RoleBadgeProps {
  role: MemberRole;
}

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[role]}`}>
      {role}
    </span>
  );
}
